import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('level_funded_benefits_set', '/level_funded_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
